<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form :inline="false"
             :model="dataForm" ref="dataForm" :rules="dataRule">
      <el-row>
        <el-col :span="7">
          <!--部门名称-->
          <el-form-item prop="name" :label="$t('res.department.departmentCnName')">
            <el-input v-model.trim="dataForm.name" maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <!--<el-col :span="7">-->
          <!--&lt;!&ndash;部门英文名称&ndash;&gt;-->
          <!--<el-form-item prop="nameEn" :label="$t('res.department.departmentEnName')">-->
            <!--<el-input v-model="dataForm.nameEn" maxlength="100"></el-input>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <!--部门代码-->
        <el-col :span="7">
          <el-form-item prop="code" :label="$t('res.department.code')">
            <el-input disabled v-model="dataForm.code"  maxlength="100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="7">
          <!--部门图标-->
          <el-form-item prop="icon" :label="$t('res.department.icon')">
            <el-upload
              class="upload-demo"
              :action="actionUrl"
              accept=".jpg,.png"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :file-list="fileList"
              :on-success="uploadSuccess"
              :limit="1"
              :on-exceed="handleExceed"
              :beforeUpload="beforeAvatarUpload"
            >
              <el-button :loading="dataListLoading" size="small" type="primary">{{$t('res.vehinfo.upFile')}}</el-button>
            </el-upload>
            <img alt="" :src="dataForm.icon" v-show="dataForm.icon !== ''"
                 style="width: 30px;height: 30px;">
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align:right;">
        <!--添加岗位-->
        <el-button :loading="dataListLoading" v-if="tableDate.length === 0 && isShowPositionBut" type="primary" size="mini" @click="addRootPosition">{{$t('res.department.addJobs')}}</el-button>
        <!--保存-->
        <el-button :loading="dataListLoading" size="mini" type="primary" @click="saveDepartment">{{$t('res.cri.save')}}</el-button>
      </div>
    </el-form>
    <div class="button-group">
      <!--展开-->
      <el-button class="el-button-columnBtn" size="mini"
                 @click="unFoldAll">{{ $t('res.classroom.unFold') }}</el-button>
      <!--收起所有-->
      <el-button class="el-button-columnBtn" size="mini"
                 @click="foldAll">{{ $t('res.classroom.fold') }}</el-button>
    </div>
    <el-table
      v-if="isShowTable"
      :data="tableDate"
      ref="tableTreeRef"
      style="width: 100%;margin-bottom: 20px;"
      v-loading="dataListLoading"
      row-key="id"
      border
      :default-expand-all="isExpand"
      :tree-props="{children: 'children'}">
      <!--岗位名称-->
      <el-table-column
        prop="positionNameCn"
        :label="$t('res.department.jobName')">
      </el-table-column>
      <!--岗位代码-->
      <el-table-column
        prop="positionCode"
        :label="$t('res.department.jobCode')"  align="center">
      </el-table-column>
      <!--排序-->
      <el-table-column
        prop="sort"
        width="200"
        :label="$t('talentpool.sort')"  align="center">
        <template slot-scope="scope">
          <div style="line-height: 34px;">
            <el-input maxlength="10" style="width: 80px!important;display: inline-block;" v-model.trim="scope.row.sort"></el-input>
            <el-button class="el-icon-success ipl"
                       @click="editSort(scope.row)"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="200"
        :label="$t('handle')">
        <template slot-scope="scope">
          <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
            <el-dropdown-menu slot="dropdown" style="width: 140px!important;">
              <!--新增下级岗位-->
              <el-dropdown-item  @click.native="addNextPosition(scope.row)">{{$t('res.departmentTemple.addNextJob')}}
              </el-dropdown-item>
              <!--修改父级岗位-->
              <el-dropdown-item v-if="scope.row.grade !== 0" @click.native="modifyParentPosition(scope.row)">{{$t('talentpool.modifyParentPositions')}}
              </el-dropdown-item>
              <!--删除-->
              <el-dropdown-item @click.native="deletePosition(scope.row)">{{$t('res.departmentTemple.delete')}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!--选择岗位-->
    <el-dialog :title="$t('res.departmentTemple.selectJob')"  :visible.sync="isShowDialog" top="15vh" width="50%" :close-on-click-modal="false">
      <el-form :inline="true" :model="positionForm" ref="positionRef" :rules="positionRule" @submit.native.prevent>
        <el-row>
          <el-col :span="12" :offset="6">
            <!--选择岗位-->
            <el-form-item prop="positionId" :label="$t('res.departmentTemple.selectJob')">
              <el-select filterable clearable collapse-tags v-model="positionForm.positionId">
                <el-option
                  v-for="item in positionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-form-item style="text-align: right">
              <!--返回按钮-->
              <el-button :loading="dataListLoading" size="mini" type="primary" @click="backPosition">{{$t('res.vehinfo.back')}}</el-button>
              <!--保存按钮-->
              <el-button :loading="dataListLoading" size="mini" type="primary" @click="savePosition">{{$t('res.cri.save')}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!--选择可修改的父岗位-->
    <el-dialog :title="$t('res.departmentTemple.selectJob')"  :visible.sync="isShowPartentDialog" top="15vh" width="50%" :close-on-click-modal="false">
      <el-form :inline="true" :model="partentPositionForm" ref="partentPositionRef" :rules="partentPositionRule" @submit.native.prevent>
        <el-row>
          <el-col :span="12" :offset="6">
            <!--选择岗位-->
            <el-form-item prop="positionTreeId" :label="$t('res.departmentTemple.selectJob')">
              <el-select filterable clearable collapse-tags v-model="partentPositionForm.positionTreeId">
                <el-option
                  v-for="item in partentPositionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-form-item style="text-align: right">
              <!--返回按钮-->
              <el-button size="mini" :loading="dataListLoading" type="primary" @click="backPartentPosition">{{$t('res.vehinfo.back')}}</el-button>
              <!--保存按钮-->
              <el-button size="mini" :loading="dataListLoading" type="primary" @click="savePartentPosition">{{$t('res.cri.save')}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      fileList: [],
      isExpand: false,
      // 已存在的岗位id数组
      positionIdArray: [],
      isShowDialog: false,
      dataListLoading: false,
      dataForm: {
        id: '',
        name: '',
        nameEn: '',
        icon: '',
        code: '',
        fileUpload: undefined
      },
      tableDate: [],
      positionForm: {
        positionId: ''
      },
      partentPositionForm: {
        positionTreeId: ''
      },
      positionList: [],
      // 可选择的父节点
      partentPositionList: [],
      selectPosition: undefined,

      // 修改父节点选中的数据
      selectPartentPosition: undefined,
      positionRule: {
        // 岗位不能为空
        positionId: [
          { required: true, message: this.$t('res.departmentTemple.job') + this.$t('res.site.notNull'), trigger: 'change' }
        ]
      },
      partentPositionRule: {
        // 岗位不能为空
        positionTreeId: [
          { required: true, message: this.$t('res.departmentTemple.job') + this.$t('res.site.notNull'), trigger: 'change' }
        ]
      },
      dataRule: {
        // 部门中文不能为空
        name: [
          { required: true, message: this.$t('res.department.departmentCnName') + this.$t('res.site.notNull'), trigger: 'blur' }
        ]
        // 部门英文名称不能为空
        // nameEn: [
        //   { required: true, message: this.$t('res.department.departmentEnName') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ]
        // // 部门代码不能为空
        // code: [
        //   { required: true, message: this.$t('res.department.code') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ]
      },
      // 新增或编辑
      type: undefined,
      // 是否是根节点
      isRoot: false,
      // 上传地址
      actionUrl: window.SITE_CONFIG['apiBaseURL'] + '/sys/config/appImgUpload',
      // 可修改的父岗位
      isShowPartentDialog: false,
      isShowTable: true,
      // 是否显示添加根岗位按钮
      isShowPositionBut: false
    }
  },
  // 进来页面初始化获取数据
  mounted () {
    this.initMethod()
    this.$eventHub.$on(this.GLOBAL.OCHART_DEPARTMENT, (data) => {
      this.initMethod()
    })
  },
  watch: {
    tableDate: function () {
      this.$nextTick(() => {
        this.expandAll()
      })
    }
  },
  methods: {
    // 初始化方法
    initMethod () {
      this.isShowPositionBut = false
      // 清空id
      this.dataForm.id = ''
      // 清空岗位table
      this.tableDate = []
      // 清空文件上传
      this.dataForm.icon = ''
      this.dataForm.fileUpload = undefined
      this.fileList = []
      this.$nextTick(() => {
        this.$refs['dataForm'] && this.$refs['dataForm'].resetFields()
      })
      this.type = this.$route.query.type
      if (this.$route.query.id !== undefined) {
        this.dataForm.id = this.$route.query.id
        if (this.type === 'edit') {
          this.getInfo()
        }
      }
    },
    handleRemove (file, fileList) {
      console.log(file)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(this.$t('talentpool.uploadLimit'))
    },
    beforeRemove (file, fileList) {
      this.dataForm.icon = ''
      this.dataForm.fileUpload = undefined
      // return this.$confirm(this.$t('delete'))
    },
    // //文件上传的校验
    beforeAvatarUpload (file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      let uploadFormat = ['jpg', 'png', 'JPG', 'PNG']
      let falg = uploadFormat.indexOf(testmsg)
      if (falg === -1) {
        this.$message.warning(this.$t('talentpool.uploadFileFormat'))
        return false
      }
      // 上传文件限制5M
      let isLt2M = file.size / 1024 / 1024 <= 5
      if (!isLt2M) {
        this.$message.warning(this.$t('talentpool.uploadDepIconLimit'))
        return false
      }
    },
    // 上传成功拿到返回的信息
    uploadSuccess (response, file, fileList) {
      let url =  response.data
      let filename = file.name
      let fileUpload = {
        fileId: 1,
        url:url,
        filename: filename
      }
      this.dataForm.fileUpload = fileUpload
      this.dataForm.icon = url

      // this.dataForm.fileUpload = response
      // this.dataForm.icon = response.url
    },
    // 调用接口获取信息，渲染页面
    getInfo () {
      this.dataListLoading = true
      let _this = this
      _this.$request.get(`/talent/department/info/${_this.dataForm.id}`).then((data) => {
        _this.dataForm.name = data.name
        _this.dataForm.nameEn = data.nameEn
        _this.dataForm.code = data.code
        _this.dataForm.id = data.id
        _this.dataForm.icon = data.icon
        _this.tableDate = data.positionTree
        // 所有岗位的id
        _this.positionIdArray = data.ids
        // 如果table中无数据，则显示选择根岗位按钮
        if (_this.tableDate.length === 0) {
          _this.isShowPositionBut = true
        }
        _this.dataListLoading = false
        // 清空文件的文件
        _this.fileList = []
      }).catch(() => {
        _this.dataListLoading = false
      })
    },
    // 查询所有岗位
    queryPosition () {
      this.positionList = []
      this.dataListLoading = true
      this.$request.get(`/talent/department/queryPositioin`).then((data) => {
        let _this = this
        // 已选择的岗位的Map
        let positionMap = new Map()
        _this.positionIdArray.forEach(function (item) {
          positionMap.set(item, item)
        })
        data.forEach(function (item) {
          if (!positionMap.has(item.positionId)) {
            let param = { value: item.positionId, label: item.positionCodeAndName }
            _this.positionList.push(param)
          }
        })
        _this.dataListLoading = false
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    savePartentPosition () {
      this.$refs['partentPositionRef'].validate((valid) => {
        if (valid) {
          this.dataListLoading = true
          this.selectPartentPosition.parentId = this.partentPositionForm.positionTreeId
          this.$request.post(
            `/talent/positiontree/savePartentPosition`, this.selectPartentPosition
          ).then((data) => {
            // 关闭弹框
            this.isShowPartentDialog = false
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.getInfo()
                this.dataListLoading = false
              }
            })
          }).catch(() => {
            this.dataListLoading = false
          })
        }
      })
    },
    // 保存岗位
    savePosition () {
      this.$refs['positionRef'].validate((valid) => {
        if (valid) {
          this.dataListLoading = true
          // 保存下级岗位
          let param = ''
          if (this.isRoot) {
            // 新增根节点
            param = {
              'departmentId': this.dataForm.id,
              'positionId': this.positionForm.positionId,
              'grade': 0
            }
          } else {
            // 新增子节点
            param = {
              'departmentId': this.selectPosition.departmentId,
              'positionId': this.positionForm.positionId,
              'parentId': this.selectPosition.id,
              'grade': this.selectPosition.grade + 1
            }
          }
          this.$request.post(
            `/talent/positiontree/save`, param
          ).then((data) => {
            // 关闭弹框
            this.isShowDialog = false
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.getInfo()
                this.dataListLoading = false
              }
            })
          }).catch(() => {
            this.dataListLoading = false
          })
        }
      })
    },
    // 返回
    backPosition () {
      this.isShowDialog = false
    },
    // 返回修改父级节点
    backPartentPosition () {
      this.isShowPartentDialog = false
    },
    // 新增下级岗位
    addNextPosition (row) {
      // 查询岗位信息
      this.queryPosition()
      // 清除下拉选
      this.positionForm.positionId = ''
      this.isShowDialog = true
      this.isRoot = false
      this.selectPosition = row
      this.$nextTick(() => {
        this.$refs.positionRef.clearValidate()
      })
    },
    // 修改父级节点
    modifyParentPosition (row) {
      // 查询可选择的父级节点
      this.queryParentPosition(row)
      // 清楚下拉选
      this.partentPositionForm.positionTreeId = ''
      this.isShowPartentDialog = true
      this.selectPartentPosition = row
      this.$nextTick(() => {
        this.$refs.partentPositionRef.clearValidate()
      })
    },
    // 查询选择的父级节点
    queryParentPosition (row) {
      this.partentPositionList = []
      this.dataListLoading = true
      this.$request.post(`/talent/positiontree/queryPartentPosition`, row).then((data) => {
        let _this = this
        data.forEach(function (item) {
          let param = { value: item.positionTreeId, label: item.positionCodeAndName }
          _this.partentPositionList.push(param)
        })
        _this.dataListLoading = false
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    // 删除岗位
    deletePosition (row) {
      let message = ''
      if (row.children.length > 0) {
        message = this.$t('res.department.deleteJob')
      } else {
        message = this.$t('res.department.deletePosition')
      }
      this.$confirm(message, this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.dataListLoading = true
        let param = {
          'id': row.id,
          'departmentId': row.departmentId,
          'version': ''
        }
        this.$request.post(
          `/talent/positiontree/delete`, param
        ).then((res) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getInfo()
              this.dataListLoading = false
            }
          })
        }).catch(() => {
          this.dataListLoading = false
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存部门
    saveDepartment () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.dataListLoading = true
          // if (!this.dataForm.icon || this.dataForm.icon === '') {
          //   this.$message.warning('请上传部门图标！')
          //   return false
          // }
          let url = ''
          if (this.type === 'add') {
            url = '/talent/department/save'
          } else if (this.type === 'edit') {
            url = '/talent/department/update'
          }
          this.$request.post(
            url, this.dataForm
          ).then((data) => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                if (this.type === 'edit') {
                  this.getInfo()
                }
                if (this.type === 'add') {
                  this.dataForm.id = data.id
                  this.dataForm.code = data.code
                  this.type = 'edit'
                  this.getInfo()
                }
                this.$nextTick(() => {
                  this.isShowPositionBut = true
                  this.dataListLoading = false
                })
              }
            })
          }).catch(() => {
            this.dataListLoading = false
          })
        }
      })
    },
    // 添加根岗位
    addRootPosition () {
      // 查询岗位信息
      this.queryPosition()
      // 清除下拉选
      this.positionForm.positionId = ''
      this.isShowDialog = true
      this.isRoot = true
      this.$nextTick(() => {
        this.$refs.positionRef.clearValidate()
      })
    },
    getRowKeys (row) {
      return row.id
    },
    /**
     * 触发所有展开图标的click事件
     */
    expandAll () {
      // 获取点击的箭头元素
      let els = document.getElementsByClassName('el-table__expand-icon')
      for (let i = 0; i < els.length; i++) {
        els[i].click()
      }
    },
    /**
     * 展开所有下级
     */
    unFoldAll () {
      this.isShowTable = false
      this.$nextTick(function () {
        this.isShowTable = true
        let _this = this
        window.setTimeout(function () {
          _this.expandAll()
        }, 300)
      })
    },
    /**
     * 收起所有下级
     */
    foldAll () {
      this.isShowTable = false
      this.$nextTick(function () {
        this.isShowTable = true
      })
    },
    /**
     * 修改排序字段
     */
    editSort (row) {
      // 如果建议值为空提示
      if (!row.sort && row.sort !== 0) {
        this.$message.warning(this.$t('talentpool.sortIsNotEmpty'))
        return false
      }
      if (!this.isPositiveInteger(row.sort)) {
        this.$message.warning(this.$t('talentpool.sortMustNumber'))
        return false
      }
      this.$request.post(`/talent/department/modifyPosiSort`, row).then((data) => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            // this.getInfo()
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 校验是否是正整数
    isPositiveInteger (s) {
      let re = /^\+?[1-9][0-9]*$/
      return re.test(s)
    }
  }
}
</script>
<style>
  /*.cell .el-table__placeholder {*/
    /*position: relative;*/
    /*margin-left: 20px;*/
  /*}*/
  .upload-demo {
    display: inline-block;
    margin-right: 30px;
  }
</style>
